import { useLegalModal } from "@/components/LegalModal";
import { useLanguage } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const f = t.footer;
  const { openImpressum, openPrivacy, Modal } = useLegalModal();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-neutral-950 text-white/80">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <a href="#home" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[#0055FF] flex items-center justify-center font-heading font-bold text-white">
              FP
            </div>
            <span className="font-heading text-lg font-bold text-white">FootPool</span>
          </a>
          <p className="mt-5 text-sm leading-relaxed max-w-sm text-white/70">
            {f.tagline}
          </p>
          <p className="mt-5 text-sm text-white/70" data-testid="footer-location">
            {f.location}
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-widest text-white/50 font-semibold">
            {f.navTitle}
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            {f.links.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="hover:text-white transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-widest text-white/50 font-semibold">
            {f.contactTitle}
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a
                href="mailto:info@footpoolevents.ch"
                className="hover:text-white transition-colors"
              >
                info@footpoolevents.ch
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-white/50">
          <div>© {year} FootPool. {f.rights}</div>
          <div className="flex gap-6">
            <button
              type="button"
              onClick={openImpressum}
              data-testid="footer-impressum"
              className="hover:text-white transition-colors"
            >
              {f.impressum}
            </button>
            <button
              type="button"
              onClick={openPrivacy}
              data-testid="footer-privacy"
              className="hover:text-white transition-colors"
            >
              {f.privacy}
            </button>
          </div>
        </div>
      </div>

      <Modal />
    </footer>
  );
};

export default Footer;
